import { FixMeLater, Selector } from "@shared/types";
import { useMemo } from "react";
import { useSelector } from "react-redux";

interface useMemoizedSelectorProps<T> {
  selectorCreator: (arg: any) => Selector<T>;
  args: FixMeLater; // args argument needs to be stable for memoization to properly work
}

const useMemoizedSelector = <T>({
  selectorCreator,
  args,
}: useMemoizedSelectorProps<T>) => {
  const selector = useMemo(
    () => selectorCreator(args),
    [selectorCreator, args]
  );
  return useSelector(selector);
};

export default useMemoizedSelector;
